import './home.css';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLatestManhwas, getLastNotification } from '../../acciones/index';
import { NavBar } from '../../componentes/navbar/index';
import { Slider } from '../../componentes/slider/slider';
import { Card } from '.././../componentes/cards/card';

import holaCo from '../.././img/slogan/1.png';

import { CardTende } from '../../componentes/cardTende/cardtende';
import { ImgCabecera } from '../../componentes/imgCabecera/imgCabe';

import { getPopularSeries } from '../../acciones/index';
import apiClient from '../../acciones/apiClient';
import { jwtDecode } from 'jwt-decode';
import AdSenseComponent from '../../componentes/adSense/adSenseComponent';

export default function Home() {

    const [seleccion, setSeleccion] = useState('hoy');


    const dispatch = useDispatch();
    const latestManhwas = useSelector((state) => state.latestManhwas);
    const lastNotification = useSelector((state) => state.lastNotification);

    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const token = localStorage.getItem("token");
                if (!token) throw new Error("No se encontró un token válido en localStorage.");

                const decodedToken = jwtDecode(token);
                console.log("Punto 1 - Token decodificado:", decodedToken);

                const userId = decodedToken.id;
                const response = await apiClient.get(`/usuarios/perfil/${userId}`);

                console.log("Punto 2 - Datos del usuario obtenidos:", response.data);
                setUser(response.data);
            } catch (err) {
                console.error("Error en fetchUserData:", err);
                setError("Error al cargar los datos del usuario.");
            } finally {
                setLoading(false);
            }
        };

        fetchUserData();
    }, []);

    useEffect(() => {
        if (user?.user_id) {
            console.log("User ID enviado a getLatestManhwas:", user.user_id);
            dispatch(getLatestManhwas(user.user_id));
        }
    }, [dispatch, user?.user_id]);


    useEffect(() => {
        dispatch(getLatestManhwas());
        dispatch(getLastNotification());
    }, [dispatch]);
    useEffect(() => {
        console.log('Proyectos recibidos:', latestManhwas); // Debug
    }, [latestManhwas]);

    const popularSeries = useSelector((state) => state.popularSeries);

    // Dentro del componente Home
    useEffect(() => {
        dispatch(getPopularSeries());
    }, [dispatch]);

    const renderTendencias = (series) => {
        return series.map((serie) => (
            <CardTende
                key={serie.proyectoId}
                id={serie.proyectoId}
                cover={serie.portada}
                title={serie.titulo}
            />
        ));
    };

    return (

        <div>
            <ImgCabecera />
            <NavBar />
            <div style={{ margin: '1rem 0' }}>
                <AdSenseComponent />
            </div>
            <div className='sliderTamaño'>
                <Slider />
            </div>
            <div style={{ margin: '1rem 0' }}>
                <AdSenseComponent />
            </div>
            <div className="holaNotiContainer">
                <img src={holaCo} alt="Hola" className="holaCo" />

                <div className="noti-container">
                    <h4 className="noti">Notificaciones</h4>
                    {lastNotification.imgNotifi ? (
                        <a href="/notificaciones">
                            <img
                                src={lastNotification.imgNotifi}
                                alt={lastNotification.titulo}
                                className="notifiIMG"
                            />
                        </a>
                    ) : (
                        <p>No hay notificaciones disponibles</p>
                    )}
                </div>
            </div>
            <div style={{ margin: '1rem 0' }}>
                <AdSenseComponent />
            </div>
            <div className="contenedorPrincipal">
                <div className="seccionActualizaciones">
                    <h1 className="ultiAd">Últimas actualizaciones</h1>
                    <div className="proyect12">
                        {latestManhwas.length > 0 ? (
                            latestManhwas.map((manhwa) => (
                                <Card
                                    key={manhwa.proyecto_id}
                                    id={manhwa.proyecto_id} // Asegúrate de pasar el ID aquí
                                    cover={manhwa.portada}
                                    title={manhwa.titulo}
                                    author={manhwa.autor}
                                />
                            ))
                        ) : (
                            <p>Cargando manhwas...</p>
                        )}

                    </div>
                    <button className='BVerMasBPrincipal'>
                        <a href='/Series'>Ver Más!!</a>
                    </button>
                </div>
                <div style={{ margin: '1rem 0' }}>
                    <AdSenseComponent />
                </div>
                <div className="contenedorTendencias">
                    <h1 className="tituloTende">TENDENCIAS</h1>
                    <div className="pestTende">
                        <a onClick={() => setSeleccion('hoy')}>Hoy</a>
                        <a onClick={() => setSeleccion('semana')}>Semana</a>
                        <a onClick={() => setSeleccion('todos')}>Todos</a>
                    </div>
                    <div className="contenidoTendencias">
                        {seleccion === 'hoy' && renderTendencias(popularSeries.hoy || [])}
                        {seleccion === 'semana' && renderTendencias(popularSeries.semana || [])}
                        {seleccion === 'todos' && renderTendencias(popularSeries.todos || [])}
                    </div>
                </div>
            </div>

        </div>

    )
};

